import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateHistoryGet } from "#candidate/services/api"
import { COLOR_PRIMARY } from "#constants/Styles"
import MainDetailsHistoryDialog from "#core/components/main-details/MainDetailsHistory"
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew"
import EditNoteIcon from "@mui/icons-material/EditNote"
import EventIcon from "@mui/icons-material/Event"
import PersonIcon from "@mui/icons-material/Person"
import PersonOffIcon from "@mui/icons-material/PersonOff"
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt"
import { useMemo } from "react"

export default function CandidateDetailsHistory({ ...props }) {
	const { candidateId } = useCandidateRedux()
	const params = useMemo(() => ({ id: candidateId }), [candidateId])
	const listItems = [
		{
			icon: <AccessibilityNewIcon />,
			key: "created",
		},
		{
			icon: <EventIcon />,
			key: "scheduled",
		},
		{
			icon: <ThumbUpAltIcon />,
			key: "interview",
		},
		{
			icon: <EditNoteIcon />,
			key: "edit",
		},
		// {
		// 	icon: <SensorOccupiedIcon />,
		// 	key: "is_enabled",
		// },
		{
			icon: <PersonOffIcon />,
			key: "disabled",
		},
		{
			icon: <PersonIcon />,
			key: "enabled",
		},
	]
	const bgcolor = (action) => {
		if (action.includes("eliminado")) return "red"
		if (action.includes("new")) return COLOR_PRIMARY
		if (action.includes("vobo")) return "green"
		if (action.includes("recepción ")) return "green"
		return COLOR_PRIMARY
	}
	return (
		<MainDetailsHistoryDialog
			{...{ apiCall: candidateHistoryGet, bgcolor, listItems, params, ...props }}
		/>
	)
}
